import React, { useContext, useEffect, useState } from 'react';
import "./newPartRequestPN.css"
import { Tooltip } from '@mui/material';
import { Dropdowns } from "../../../../../components/Dropdowns/Dropdowns"
import { HTTP_RESPONSE_CODES } from '../../../../../globals/globals';
import { dropdownConfig } from '../../../../../services/dropdownsConfigService';
import Skeleton from 'react-loading-skeleton';
import Input from '../../../../../components/Inputs/Input';
import { DeleteNewPartRequestPNModal } from './deleteNewPartRequestPN/DeleteNewPartRequestPNModal';
import { DialogContext } from '../../../../../contexts/DialogContext';
import { usePermissions } from '../../../../../hooks/usePermissions';

export const NewPartRequestPN = ({ index, updatePNQuantity, updatePNPartId, childDropdownId, parentValues, dependenciesToUpdate, updatePNUOMId, initialData, deletePnCard, prnStatus , taskID , fndID }) => {

    const [PNDrop, setPNDrop] = useState(null);
    const [QTY, SetQTY] = useState(null);
    const [PNSelected, setPNSelected] = useState(null);
    const [preselectPN, setPreselectPN] = useState(null);
    const { openDialog, closeDialog } = useContext(DialogContext);
    const { hasPermission } = usePermissions();
    const [pnParameter , setPnParameter] = useState(null);

    // functions
    const openDeleteDialog = () => {
        if (prnStatus == "Posted") {
            return;
        } else {
            openDialog({
                component: DeleteNewPartRequestPNModal,
                props: {
                    onClose: closeDialog,
                    pn: PNSelected?.["p.part_number"] ? PNSelected?.["p.part_number"] : "--",
                    category: PNSelected?.category_name ? PNSelected?.category_name : "--",
                    deletePn: deletePN,
                }
            })
        }
    }

    const deletePN = () => {
        try {
            deletePnCard(initialData.id);
        } catch (error) {
            console.error(error)
        }
    }

    const getDropdownConfigPN = async () => {
        let id = 71;
        const request = await dropdownConfig(id);
        if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            setPNDrop(request.data.load);
        }
    }


    const getAllDropdowns = async () => {
        const results = await Promise.all([
            getDropdownConfigPN(),
            // getDropdownConfigUOM(),
        ])

        return results
    }

    useEffect(() => {
        getAllDropdowns()

    }, [])
    useEffect(()=> {
        setPnParameter([{
            columnName : "taskCardId",
            value : [taskID]
        }])
    } ,[taskID])

    useEffect(() => {
        if (initialData) {
            SetQTY(initialData.quantity || 0);
            setPreselectPN(initialData.partId || null);
        }
    }, [initialData]);


    const getPNSelection = (data) => {
        setPNSelected(data);
        updatePNPartId(index, data["p.id"]);
        updatePNUOMId(index, data["uom_id"])
    };

    const handleQTYChange = (e) => {
        const newQTY = e.target.value;
        SetQTY(newQTY);
        updatePNQuantity(index, newQTY);
    };

    // const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    //     let setDropdown;

    //     switch (dropdownId) {
    //         case 71:
    //             setDropdown = setPNDrop;
    //             break;
    //         default:
    //             return;
    //     }

    //     const debounceUpdate = setTimeout(() => {
    //         setDropdown((prevState) => ({
    //             ...prevState,
    //             parentValues,
    //             dependenciesToUpdate,
    //             reload: true,
    //         }));
    //     }, 200);

    //     return () => clearTimeout(debounceUpdate);
    // };

    const resetDropdownsReload = () => {
        setPNDrop((prevState) => ({ ...prevState, reload: false }));
    };


    // useEffect(() => {
    //     if (PNDrop != null) {
    //         setPNDrop(prevState => ({
    //             ...prevState,
    //             parentValues,
    //             dependenciesToUpdate,
    //             reload: true,
    //         }));
    //     }


    //     if (!initialData) {
    //         setPNSelected(null);
    //         SetQTY(0);
    //     }
    // }, [childDropdownId, parentValues, dependenciesToUpdate]);

    return (
        <section className='NewPartRequestPN'>
            <div>
                <p>PN</p>
                <div style={{
                    flexGrow: 1,
                }}>
                    {
                        PNDrop ? <Dropdowns parameters={pnParameter} preventSelectionWithPreselect={false} preSelectValue={preselectPN} hideLabel={true} placeholder={true} resetDropdownsReload={resetDropdownsReload} onOptionSelect={getPNSelection} data={PNDrop}></Dropdowns> : <Skeleton height="2rem" width="100%" />
                    }
                </div>
            </div>

            <div>
                <p>QTY</p>
                <Input allowDecimals={PNSelected?.category_name == "Serialized" && PNSelected?.uom_id == 18 ? false : true} isNumeric={true} placeholder='QTY' value={QTY} onChange={(e) => {
                    handleQTYChange(e);
                }} />

            </div>

            <p>
                UOM
                <span>
                    {
                        PNSelected?.uom_name ? PNSelected.uom_name : "--"
                    }
                </span>
            </p>
            <p>
                Category
                <span>
                    {
                        PNSelected?.category_name ? PNSelected.category_name : "--"
                    }
                </span>
            </p>

            <p>
                Sub Category
                <span>
                    {
                        PNSelected?.sub_category_name ? PNSelected.sub_category_name : "--"
                    }
                </span>
            </p>
            {
                hasPermission("deletePN") &&
                <Tooltip arrow title={prnStatus == "Posted" ? "Cannot be deleted because the PRN status is Posted" : "Delete"} >
                    <button onClick={openDeleteDialog}>
                        <i className='icon-delete-new' style={{
                            opacity: prnStatus == "Posted" ? 0.5 : 1
                        }}></i>
                    </button>
                </Tooltip>}
        </section>
    )
}
